import { render } from "./kaplermodel.vue?vue&type=template&id=0a817bc4"
import script from "./kaplermodel.vue?vue&type=script&lang=js"
export * from "./kaplermodel.vue?vue&type=script&lang=js"

import "./kaplermodel.vue?vue&type=style&index=0&id=0a817bc4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__